export default __webpack_public_path__ + "static/media/hand-glov-blk.5f4875ae.svg";